<template>
	<div class="chapter container">
		<div class="chapter__header">
			<small class="chapter__small-label">Chapter {{ chapterId }}</small>
			<page-title>{{ chapterSource.meta.title }}</page-title>
		</div>
		<div class="chapter__content">
			<div 
				v-for="(data, index) in chapterSource.content"
				:key="index"
				class="chapter__content--row"
			>
				<h2 v-if="data.subTitle">{{ `${chapterId}.${index} ${data.subTitle}` }}</h2>
				<p	
					v-if="data.data"
					v-html="data.data"
				/>
			</div>
		</div>
		<div class="chapter__controls">
			<router-link
				:to="`/chapter/${parseInt(chapterId) - 1}`"
				tag="div"
				class="chapter__controls--prev"
				v-if="prevChapter.status"
			>
				<font-awesome-icon 
					icon="angle-left" 
				/>
				<div>
					Prev
					<small>{{ prevChapter.title }}.</small>
				</div>
			</router-link>
			<router-link
				:to="`/chapter/${parseInt(chapterId) + 1}`"
				tag="div"
				class="chapter__controls--next"
				v-if="nextChapter.status"
			>	
				<div>
					Next
					<small>{{ nextChapter.title }}</small>
				</div>
				<font-awesome-icon 
					icon="angle-right" 
				/>
			</router-link>
			<div 
				v-else
				class="chapter__controls--next the-end"
			>
				The End...
			</div>
		</div>
	</div>
</template>

<script>
	import meta from '@data/meta.json';
	import PageTitle from '@/ui/components/PageTitle';
	import { chapterSource } from '@/helpers/content.js';

	export default {
		components: {
			PageTitle,
		},
		data() {
			return {
				prevChapter: {
					status: false,
					title: ''
				},
				nextChapter: {
					status: false,
					title: ''
				}
			}
		},
		computed: {
			chapterId() {
				return this.$route.params.chapterId;
			},
			chapters() {
				return meta.chapters;
			},
			chapterSource() {
				return chapterSource(this.chapters[this.chapterId - 1]);
			}
		},
		watch: {
			$route() {
				this.validateChapterId();
				this.validateChartControls();

				window.scroll({
                    top: 0,
                    behavior: 'smooth'
                })
			}
		},
		mounted() {
			this.validateChapterId();
			this.validateChartControls();
		},
		methods: {
			validateChapterId() {
				if (!this.chapters[this.chapterId - 1]) {
					this.$router.push('/404');
				}
			},
			validateChartControls() {
				const chapterIdIndex = parseInt(this.chapterId - 1);
				const prevChapterIndex = chapterIdIndex - 1;
				const nextChapterIndex = chapterIdIndex + 1;

				this.prevChapter.status = this.chapters[prevChapterIndex];
				if (this.prevChapter.status) {
					this.prevChapter.title = chapterSource(this.chapters[prevChapterIndex]).meta.title;
				}

				this.nextChapter.status = this.chapters[nextChapterIndex];
				if (this.nextChapter.status) {
					this.nextChapter.title = chapterSource(this.chapters[nextChapterIndex]).meta.title;
				}
			}
		}
	};
</script>

<style lang="scss">
	.chapter {
		&__small-label {
			font-weight: 600;
		}

		&__content {
			font-size: 0.98em;
			line-height: 1.3em;

			&--row {
				margin-bottom: 3em;
			}

			h2 {
				font-size: 1.3em;
			}
		}

		&__controls {
			display: flex;
			flex: 1;

			& > div {
				color: $_copy_alt;
				cursor: pointer;
				align-self: center;

				&:hover {
					color: $primary;
				}

				flex: 1;
				font: {
					weight: 600;
				}

				div {
					max-width: 80%;
				}

				@include tablet {
					font: {
						size: 1.3em;
						weight: 600;
					}

					svg {
						font-size: 2em;
					}
				}
				
				div, svg {
					display: inline-block;
					vertical-align: middle;
				}

				small {
					display: block;
					opacity: 0.9;
					text-transform: uppercase;
					font-size: 0.65em;
				}
			}
			
			&--prev {
				svg {
					margin-right: 0.25em;
				}
			}

			&--next {
				text-align: right;
				svg {
					margin-left: 0.25em;
				}
			}

			.the-end {
				&:hover {
					color: inherit;
				}
				cursor: auto;
			}
		}
	}
</style>
